import axios from 'axios';

export const uploadFile = async (file, institutionCode) => {
	const formData = new FormData();
	formData.append('file', file, file.name);
	formData.append('institution_code', institutionCode);

	try {
		const response = await axios.post(`/resources/by-urls`, formData, {
			headers: {
				accept: 'application/json',
				Authorization: `Bearer ${localStorage.token}`,
				'Content-Type': 'multipart/form-data',
			},
		});

		return response.data;
	} catch (error) {
		throw error;
	}
};
